import {
  Dialog,
  DialogTitle,
  List,
  Button,
  makeStyles,
} from "@material-ui/core";
import { useMap } from "react-leaflet";

const useStyles = makeStyles({
  volarList: {
    display: "flex",
    flexDirection: "column",
    paddingBottom: "20px",
  },
  volarBtn: {
    margin: "5px 20px",
    textTransform: "none",
    fontWeight: "400",
  },
  volarTitle: {
    textAlign: "center",
    paddingBottom: "0px",
  },
});

const MapDialog = ({ open, handleClose }) => {
  const classes = useStyles();
  const map = useMap();

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle className={classes.volarTitle}>Ciudad</DialogTitle>
      <List className={classes.volarList}>
        {volarItems.map((item, idx) => (
          <Button
            className={classes.volarBtn}
            variant="contained"
            color="primary"
            key={idx}
            onClick={() => {
              map.setView(item.location, 9);
              handleClose();
            }}
          >
            {item.name}
          </Button>
        ))}
      </List>
    </Dialog>
  );
};

const volarItems = [
  {
    name: "Los Mochis",
    location: [25.792427, -108.988868],
  },
  {
    name: "Guasave",
    location: [25.563474, -108.462046],
  },
  {
    name: "Guamúchil",
    location: [25.459545, -108.083777],
  },
  {
    name: "Culiacán",
    location: [24.8080149, -107.3926665],
  },
  {
    name: "Mazatlán",
    location: [23.205231, -106.420034],
  },
  {
    name: "Escuinapa",
    location: [22.833356, -105.77685],
  },
];

export default MapDialog;
